"use client"

export const isAndroid = (): boolean => {
  if (typeof navigator === "undefined") return false
  return /android/i.test(navigator.userAgent)
}

export const isIOS = (): boolean => {
  if (typeof navigator === "undefined") return false
  return /iPhone|iPad|iPod/i.test(navigator.userAgent)
}

export const isStandalone = (): boolean => {
  if (typeof window === "undefined") return false
  return window.matchMedia("(display-mode: standalone)").matches
}
